var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"primary-fill","d":"M1216 832c0-123.3-43.8-228.8-131.5-316.5S891.3 384 768 384s-228.8 43.8-316.5 131.5S320 708.7 320 832s43.8 228.8 131.5 316.5S644.7 1280 768 1280s228.8-43.8 316.5-131.5S1216 955.3 1216 832zM1728 1664c0 34.7-12.7 64.7-38 90s-55.3 38-90 38c-36 0-66-12.7-90-38l-343-342c-119.3 82.7-252.3 124-399 124 -95.3 0-186.5-18.5-273.5-55.5s-162-87-225-150 -113-138-150-225S64 927.3 64 832s18.5-186.5 55.5-273.5 87-162 150-225 138-113 225-150S672.7 128 768 128s186.5 18.5 273.5 55.5 162 87 225 150 113 138 150 225S1472 736.7 1472 832c0 146.7-41.3 279.7-124 399l343 343C1715.7 1598.7 1728 1628.7 1728 1664z"}));
}

SearchIcon.defaultProps = {"viewBox":"0 0 1792 1792","className":"icon search"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
